// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 4 hooks for backend/discipleship.

import { useBackend } from '../useBackend'

/** POST /api/discipleship/getManualIndex */
export function useGetManualIndex<T = any>() {
  return useBackend<T>('discipleship/getManualIndex')
}

/** POST /api/discipleship/getManualPart */
export function useGetManualPart<T = any>() {
  return useBackend<T>('discipleship/getManualPart')
}

/** POST /api/discipleship/getManualSearch */
export function useGetManualSearch<T = any>() {
  return useBackend<T>('discipleship/getManualSearch')
}

/** POST /api/discipleship/openPageHelp */
export function useOpenPageHelp<T = any>() {
  return useBackend<T>('discipleship/openPageHelp')
}
